import { Text } from '@shared/components'
import { useSessionContext } from '@shared/hooks'
import { getFormatCurrency } from '@shared/utils'
import { DescriptionsProps, Divider, Flex, Form } from 'antd'
import { useTranslation } from 'react-i18next'

import { DetailsWrapper } from '../DetailsWrapper'

const priceKey = { name: 'price' }
const creditProps = { name: 'credit' }

export type InsuranceRcaDescriptionItem =
  Required<DescriptionsProps>['items'][number] & {
    hidden?: boolean
  }

type Props = {
  items: InsuranceRcaDescriptionItem[]
}

export const InsuranceRcaDetails = ({ items }: Props) => {
  const { t } = useTranslation()
  const { broker } = useSessionContext()

  const credit = Form.useWatch(creditProps.name, { preserve: true })
  const price = Form.useWatch(priceKey.name, { preserve: true })

  const totalToBePaid = (price?.amount || 0) - (credit || 0)

  return (
    <DetailsWrapper items={items}>
      {price && (
        <>
          {!broker && !!credit && (
            <>
              <Flex align="center" justify="space-between">
                <Text strong size={18}>
                  {t('order_amount_paid')}
                </Text>
                <Text strong size={18} className="text-wrap-nowrap">
                  {getFormatCurrency(price)}
                </Text>
              </Flex>

              <Flex align="center" justify="space-between">
                <Text strong size={18}>
                  {t('amount_used_from_balance')}
                </Text>
                <Text strong size={18} className="text-wrap-nowrap">
                  {getFormatCurrency({ amount: credit })}
                </Text>
              </Flex>
            </>
          )}

          <Flex align="center" justify="space-between">
            <Text strong size={18}>
              {t('total_to_be_paid')}
            </Text>
            <Text strong size={18} className="text-wrap-nowrap">
              {getFormatCurrency({ amount: totalToBePaid })}
            </Text>
          </Flex>

          <Divider />
        </>
      )}
    </DetailsWrapper>
  )
}
